import { Component, inject } from '@angular/core';

import { CamDeviceInfoService } from '@camelot/capacitor';
import { CamDynamicTranslationService } from '@camelot/core';
import { CAM_AUTH_TOKEN, CamAuthService } from '@camelot/user';

import { BaseComponent } from './features/core/abstract/base-component';
import { AppTranslationApplication } from './services/translation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent extends BaseComponent {
  title = 'Camelot';

  private authService = inject<CamAuthService<any>>(CAM_AUTH_TOKEN);
  private _deviceInfoService = inject(CamDeviceInfoService);

  constructor() {
    super();

    AppTranslationApplication.getInstance();
    CamDynamicTranslationService.getInstance();
    this.authService.load();
    this.setBodyClasses();
  }

  private setBodyClasses() {
    this._deviceInfoService.deviceClasses$.subscribe(classes => {
      for (let classToAdd of classes.filter(x => x.length > 0)) document.body.classList.add(classToAdd);
    });
  }
}
